import React, { PureComponent } from 'react';
import styled from 'styled-components';
import ReportItem from './ReportItem';
import ExpandCollapseIcon from './assets/ExpandCollapse.svg';
import Collapsible from 'react-collapsible';

const StyledList = styled.ul`
  padding: 0;
  width: 100%;
  list-style-type: none;
`;

const StyledListItem = styled.li`
  width: 100%;
`;

const ReportClientMenuItemImg = styled.img`
  ${props => (props.expanded ? '' : 'transform : rotate(-90deg);')};
  opacity: 1;
  vertical-align: middle;
  margin-right: 9px;
`;

const StyledListItemName = styled.span`
  vertical-align: top;
`;

const StyledListItemButton = styled.button`
  width: 100%;
  border: none;
  box-sizing: border-box;
  padding: 10px 50px 10px 30px;
  margin: 0;
  text-decoration: none;
  background-color: ${props => (props.expanded ? '#00013e' : '#00013e')};
  color: rgba(255, 255, 255, 0.8);
  font-family: inherit;
  font-size: 20px;
  border-radius: 0;
  cursor: pointer;
  text-align: initial;
  -webkit-appearance: none;
  -moz-appearance: none;
  &:hover,
  &:focus {
    background-color: rgba(255, 255, 255, 0.2);
    color: #white;
  }
`;

class ReportClientItem extends PureComponent {
  constructor(props) {
    super(props);
  }

  getStyledListItembutton() {
    const { reportClient, tabIndex, ...props } = this.props;
    return (
      <StyledListItemButton onClick={this.toggleState} tabIndex={tabIndex}>
        <ReportClientMenuItemImg
          alt=""
          src={ExpandCollapseIcon}
          expanded={true}
        />
        <StyledListItemName>{reportClient.client}</StyledListItemName>
      </StyledListItemButton>
    );
  }

  render() {
    const {
      reportClient,
      reportsVersions,
      selectedReportId,
      selectedReportPageId,
      selectedReportTabId,
      ...props
    } = this.props;

    return (
      <StyledListItem>
        <Collapsible
          trigger={this.getStyledListItembutton()}
          open={true}
        >
          <StyledList>
            {reportClient.reports.map(report => {
              const versionString = reportsVersions.find(
                reportVersion => reportVersion.id === report.id
              ).versionString;

              return (
                <ReportItem
                  key={report.id}
                  report={report}
                  reportVersionString={versionString}
                  selectedReportId={selectedReportId}
                  selectedReportPageId={selectedReportPageId}
                  selectedReportTabId={selectedReportTabId}
                />
              );
            })}
          </StyledList>
        </Collapsible>
      </StyledListItem>
    );
  }
}

export default ReportClientItem;
